<template>
  <div v-if="modal">
    <div class="modal-pdv show">
      <div class="modal-pdv-content">
        <div class="container-fluid">
          <div class="row no-gutters align-items-center justify-content-between mb-2 border-bottom">
            <div class="col-8 pr-sm-1 mb-2 text-ellipsis">
              Créditos | {{cliente.nome_cliente}}
            </div>
            <div class="col-4 text-right mb-2" v-show="menu === 1">
              <button class="btn btn-secondary" @click="adicionarConta"><i class="fa fa-plus mr-1"></i> Adicionar</button>
            </div>
            <div class="col-4md-4 text-right mb-2" v-show="menu === 2 && dados.id_conta">
              <button class="btn btn-third" @click="comprovanteConta(dados.id_conta)"><i class="fa fa-print"></i></button>
              <button class="btn btn-primary ml-1" @click="removerConta()" v-if="!dados.id_comanda"><i class="fa fa-trash-alt mr-1"></i> Remover</button>
            </div>
          </div>
          <div v-show="menu === 1">
            <div class="row no-gutters">
              <div class="col-md-8 pr-md-2">
                <div class="border rounded height-50">
                  <div class="table-responsive">
                    <div class="d-flex justify-content-center align-items-center" style="min-height: 150px" v-if="!extrato.transacoes.length">
                      <loading v-if="load"/>
                      <small v-else>Nenhuma transação disponível</small>
                    </div>
                    <table class="table table-sm mb-0" v-else>
                      <tr class="bg-light">
                        <th class="font-weight-normal">Transações</th>
                        <th>&nbsp;</th>
                      </tr>
                      <tr v-for="t in extrato.transacoes">
                        <td class="align-middle pointer" @click="visualizarTransacao(t)">
                          <div class="small"><b>{{ t.tipo_conta === '1' ? 'Entrada' : 'Saída' }}</b> | {{ t.data_conta }}</div>
                          <div :class="t.tipo_conta === '1' ? 'text-success' : 'text-danger'">{{t.valor | valor }}</div>
                        </td>
                        <td class="text-right text-nowrap">
                          <button class="btn btn-sm text-secondary" @click="comprovanteConta(t.id_conta)" title="Imprimir">
                            <i class="fa fa-print"></i>
                          </button>
                          <button class="btn btn-sm text-third" @click="visualizarTransacao(t)" title="Visualizar">
                            <i class="fa fa-chevron-right"></i>
                          </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="border rounded p-2">
                  <h5 class="mb-1">{{ extrato.saldo | valor}}</h5>
                  <div class="small font-weight-bold">Saldo</div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="menu === 2">
            <div class="alert alert-info mb-2" v-if="!dados.id_conta">
              <div>Novo saldo: <b>{{ parseFloat(extrato.saldo) + (dados.valor * (dados.tipo_conta === '2' ? -1 : 1)) | valor}}</b></div>
              <div class="small">Saldo atual: {{ extrato.saldo | valor}}</div>
            </div>
            <div class="row no-gutters">
              <div class="col-md-4 pr-md-2 mb-1">
                <label class="mb-0 small">Tipo</label>
                <select class="form-control" v-model="dados.tipo_conta" :disabled="dados.id_conta">
                  <option value="1">Entrada</option>
                  <option value="2">Saída</option>
                </select>
              </div>
              <div class="col-md-4 pr-md-2 mb-1">
                <label class="mb-0 small">Valor</label>
                <money v-model="dados.valor" id="valorConta" class="form-control" :disabled="dados.id_conta"/>
              </div>
              <div class="col-md-4 pr-md-2 mb-1" v-if="!dados.id_comanda">
                <label class="small mb-0">Forma de Pagamento</label>
                <select title="Forma de Pagamento" class="form-control" v-model="dados.id_pagamento" :disabled="dados.id_conta">
                  <option :value="f.id_pagamento" v-for="f in formas_pagamento">{{f.nome_pagamento}}</option>
                </select>
              </div>
              <div class="col-md-12 mb-3">
                <label class="mb-0 small">Observações (opcional)</label>
                <textarea class="form-control" placeholder="Informe aqui uma observação da transação" rows="2" v-model="dados.observacao" :disabled="dados.id_conta"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="menu === 1 ? modal = false : menu = 1">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button class="btn btn-secondary" v-show="menu === 2 && !dados.id_conta" @click="salvarConta()">
            <i class="fa fa-check mr-2"></i> Adicionar
          </button>
        </div>
      </div>
    </div>

    <caixa ref="credCaixa" @finalizarVenda="salvarConta()"/>
  </div>
</template>

<script>
  import Tooltip from "@/components/commons/Tooltip";
  import Caixa from "@/views/comanda/pdv/Caixa";
  import Loading from "@/components/commons/Loading";

  export default {
    name: "ClienteCredito",
    components: {Loading, Caixa, Tooltip},

    data() {
      return {
        token: localStorage.getItem('key'),
        modal: false,
        menu: 1,
        load: false,
        dados: {
          id_cliente: null,
          id_debito: null,
          data_conta: '',
          tipo_conta: '1',
          id_pagamento: '1',
          valor: 0,
          observacao: ''
        },
        pesquisa: { tipo_conta: '1' },
        cliente: {},
        extrato: { transacoes: [], saldo: 0 },
        formas_pagamento: [],
      }
    },

    methods: {
      buscarExtratoConta() {
        if (this.load) {
          return;
        }

        this.load = true;
        this.menu = 1;
        this.extrato = { transacoes: [], saldo: 0 };
        this.pesquisa.tipo_conta = '1';

        this.$http.get('pdv/clientes/creditos/' + this.token + '/' + this.cliente.id_cliente)
          .then(response => {
            this.$store.state.load = false;
            this.load = false;

            if (!response.data) {
              return;
            }

            this.extrato = response.data;

          }, res => {
            this.load = false;
            this.$store.state.load = false;
            this.$swal(res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      salvarConta() {
        if (!this.dados.remover && this.dados.valor <= 0) {
          this.$swal('Por favor, informe um valor válido').then(() => {
            document.getElementById('valorConta').focus();
          });
          return;
        }

        this.$store.state.load = true;
        this.dados.id_cliente = this.cliente.id_cliente;

        this.$http.post('pdv/clientes/creditos/' + this.token, this.dados)
          .then(res => {
            this.$store.state.load = false;

            if (res.data && res.data.result) {
              switch (res.data.result) {
                case 'success':
                  this.buscarExtratoConta();
                  const id_conta = res.data.id_conta;

                  if (!this.dados.remover) {
                    this.$swal({
                      text: "Transação realizada com sucesso! Deseja imprimir o comprovante?",
                      buttons: ['Não', 'Sim']
                    }).then((res) => {
                      if (res) {
                        this.comprovanteConta(id_conta);
                      }
                    });
                  }

                  return;

                case 'caixa':
                  this.$refs.credCaixa.abrirCaixa();
                  return;
              }
            }

            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      adicionarConta() {
        this.dados = {
          id_cliente: null,
          id_debito: null,
          id_pagamento: '1',
          data_conta: new Date().toDateInputValue(),
          tipo_conta: '1',
          valor: 0,
          observacao: ''
        }

        this.menu = 2;
        this.$helpers.focusElement('valorConta')
      },

      removerConta() {
        this.$swal({
          text: 'Deseja realmente remover esta transação?',
          buttons: ['Não', 'Sim']
        }).then((res) => {
          if (res) {
            this.dados.remover = '1';
            this.salvarConta();
          }
        })
      },

      visualizarTransacao(t) {
        this.menu = 2;
        this.dados = t;
      },

      comprovanteConta(id_conta) {
        const url = `${this.base_server}api/comprovante/credito/${this.token}?id_conta=${id_conta}&`;
        const empresa = localStorage.getItem('token');
        this.$helpers.imprimirUrl(this, url, empresa, "Comprovante Crédito");
      }
    },

    mounted() {
      this.formas_pagamento = this.$store.state.pagamentos_empresa.filter(f => f.id_pagamento !== '2');
    },

    created() {
      this.$parent.$on('openCredito', (dados) => {
        if (!dados) {
          return;
        }

        this.modal = true;
        this.cliente = dados;
        this.buscarExtratoConta();
      });
    }
  }
</script>

<style scoped>
  .height-50 {
    /*height: calc(100vh - 282px);*/
  }
</style>
